/** 菜单唯一读取入口：数据库失败透传，索引由同一次响应派生。 */
import type { MenuLeaf, MenuModule } from '../mock/app-menus'
import { apiGet } from './http-client'
export type MenuLeafIndex = Record<string, { leaf: MenuLeaf; mod: MenuModule }>
export function indexMenus(modules: MenuModule[]): MenuLeafIndex {
  const index: MenuLeafIndex = Object.create(null)
  for (const mod of modules) for (const leaf of mod.items) {
    if (index[leaf.id]) throw new Error('菜单存在重复标识')
    index[leaf.id] = { leaf, mod }
  }
  return index
}
/** 套餐门控范围：known=全部菜单路径，allowed=放行路径（null=不限制） */
export interface MenuScope { known: string[]; allowed: string[] | null }
let scopeCache: Promise<MenuScope> | null = null

export const menuRepo = {
  modules: () => apiGet<MenuModule[]>('/api/menus/modules'),
  async load() {
    const modules = await this.modules()
    return { modules, leafIndex: indexMenus(modules) }
  },
  async leafIndex(): Promise<MenuLeafIndex> { return (await this.load()).leafIndex },
  /** 套餐门控范围（会话级缓存；切租户经整页刷新自然失效） */
  scope(): Promise<MenuScope> {
    if (!scopeCache) {
      scopeCache = apiGet<MenuScope>('/api/menus/scope').catch(e => { scopeCache = null; throw e })
    }
    return scopeCache
  }
}
